import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { Pagable } from 'src/app/lem/models/common/pagable';
import { PaginatedResponse } from 'src/app/lem/models/common/paginated-response';
import { RequestRole, Role } from 'src/app/lem/models/common/role';
import { CompaniesDepartment, CompanyDepartmentRequest, CompanyDepartmentType } from 'src/app/lem/models/departments/departments';
import { CompanyDepartmentMember, RequestCompanyDepartmentMember } from 'src/app/lem/models/departments/member/member';

@Injectable({
  providedIn: 'root'
})
export class DepartmentsService {


  companyPath = ServicePathsSettings.URL_COMPANIES ;
  departmentsPath = this.companyPath + ServicePathsSettings.URL_COMPANIES_DEPARTMENTS;
  typePath = this.departmentsPath + ServicePathsSettings.URL_TYPES;
  bulkPath = this.departmentsPath + ServicePathsSettings.URL_BULK;

  rolesPath = this.departmentsPath + ServicePathsSettings.URL_MEMBERS + ServicePathsSettings.URL_ROLE;

  private _refreshRequired$ = new Subject<void>();

  constructor(
    private http : HttpClient,
  ) {}

  get RefreshRequired$ () {
    return this._refreshRequired$.asObservable();
  }

  bulk(request: CompanyDepartmentRequest): Observable<CompaniesDepartment> {
    return this.http.post<CompaniesDepartment>(this.bulkPath,request);
  }

  delete(id: string): Observable<CompaniesDepartment[]> {
    return this.http.delete<CompaniesDepartment[]>(this.departmentsPath+'/'+id);
  }

  getAll(obj: any , params: Map<string,string> , pagable:Pagable ): Observable<PaginatedResponse<CompaniesDepartment>> {
    let queryParams = new HttpParams({});
    if(obj){
      queryParams = new HttpParams({ fromObject: obj});
    } else if(params){
      params.forEach((value: string, key: string) => {
        queryParams = queryParams.append(key, value);
      });
    }
    if(pagable){
      queryParams = queryParams.append('page', ''+pagable.page);
      queryParams = queryParams.append('size', ''+pagable.size);
    }

    const requestOptions = { params: queryParams };
 
    return this.http.get<PaginatedResponse<CompaniesDepartment>>(this.departmentsPath,requestOptions);
  }

  fineById(id: string): Observable<CompaniesDepartment> {
    return this.http.get<CompaniesDepartment>(this.departmentsPath+'/'+id);
  }

  getAllTypes(): Observable<PaginatedResponse<CompanyDepartmentType>> {
    return this.http.get<PaginatedResponse<CompanyDepartmentType>>(this.typePath);
  }

  addRole(request: RequestRole){
    return this.http.post<CompaniesDepartment>(this.rolesPath,request);
  }

  deleteRole(id: string): Observable<CompaniesDepartment[]> {
    return this.http.delete<CompaniesDepartment[]>(this.rolesPath+'/'+id);
  }

  getAllRoles(obj: any , params: Map<string,string> , pagable:Pagable ){
    let queryParams = new HttpParams();
    if(obj){
      queryParams = new HttpParams({ fromObject: obj});
    } else if(params){
      params.forEach((value: string, key: string) => {
        queryParams = queryParams.append(key, value);
      });
    }

    if(pagable){
      queryParams = queryParams.append('page', ''+pagable.page);
      queryParams = queryParams.append('size', ''+pagable.size);
    }
    const requestOptions = { params: queryParams };
    return this.http.get<PaginatedResponse<Role>>(this.rolesPath,requestOptions);
  }

  getAllMembersAssociated(){
    return this.http.get<string[]>(this.departmentsPath + ServicePathsSettings.URL_ALL_MEMBERS_ASSOCIATED);
  }

  getAllMembers(idCompany:string , idDepartment:string , params:Map<string,string> , pagable:Pagable){
    let queryParams = new HttpParams();
    if(params){
      params.forEach((value: string, key: string) => {
        queryParams = queryParams.append(key, value);
      });
    }

    if(pagable){
      queryParams = queryParams.append('page', ''+pagable.page);
      queryParams = queryParams.append('size', ''+pagable.size);
    }
    const requestOptions = { params: queryParams };
    return this.http.get<PaginatedResponse<CompanyDepartmentMember>>(this.companyPath + 
      "/" + idCompany +  
      ServicePathsSettings.URL_COMPANIES_DEPARTMENTS + 
      "/" + idDepartment + 
      ServicePathsSettings.URL_MEMBERS,requestOptions);
  }

  createMember(idCompany:string , idDepartment:string , request: RequestCompanyDepartmentMember){
    return this.http.post<CompanyDepartmentMember>(this.companyPath + 
      "/" + idCompany +  
      ServicePathsSettings.URL_COMPANIES_DEPARTMENTS + 
      "/" + idDepartment + 
      ServicePathsSettings.URL_MEMBERS,request);
  }

  updateMember(idCompany:string , idDepartment:string , memberId:string, request: RequestCompanyDepartmentMember){
    return this.http.put<CompanyDepartmentMember>(this.companyPath + 
      "/" + idCompany +  
      ServicePathsSettings.URL_COMPANIES_DEPARTMENTS + 
      "/" + idDepartment + 
      ServicePathsSettings.URL_MEMBERS +
      "/" + memberId,request);
  }

  deleteMember(idCompany:string , idDepartment:string , memberId:string){
    return this.http.delete<CompanyDepartmentMember>(this.companyPath + 
      "/" + idCompany +  
      ServicePathsSettings.URL_COMPANIES_DEPARTMENTS + 
      "/" + idDepartment + 
      ServicePathsSettings.URL_MEMBERS +
      "/" + memberId);
  }

  transferMember(idCompany:string , idDepartment:string , memberId:string , idDepartmentTo:string , request: RequestCompanyDepartmentMember){
    return this.http.put<CompanyDepartmentMember>(this.companyPath + 
      "/" + idCompany +  
      ServicePathsSettings.URL_COMPANIES_DEPARTMENTS + 
      "/" + idDepartment + 
      ServicePathsSettings.URL_MEMBERS +
      "/" + memberId + "/departmentTo/" + idDepartmentTo , request);
  }


}
